import React from 'react';
import {
  makeStyles, mergeClasses, shorthands, tokens,
} from '@fluentui/react-components';
import { ISingleTextSuggestionProps, SingleTextSuggestion } from './SingleTextSuggestion';
import { ITextAsset } from './types.d';

const useTextSuggestionListStyle = makeStyles({
  description: {
    color: tokens.colorNeutralForeground2,
    fontSize: tokens.fontSizeBase300,
    lineHeight: tokens.lineHeightBase300,
    fontWeight: tokens.fontWeightSemibold,
    ...shorthands.margin(tokens.spacingHorizontalL, 0),
  },
  suggestions: {},
  suggestionItem: {
    marginBottom: tokens.spacingHorizontalS,
    '&:last-child': {
      marginBottom: 0,
    },
  },
});

export interface ITextSuggestionListProps {
  suggestions: ITextAsset[];
  className?: string;
  description?: string;
  onSelect: ISingleTextSuggestionProps['onSelect'];
  buttonText?: string;
}

export const TextSuggestionList: React.FC<ITextSuggestionListProps> = React.memo(({
  suggestions,
  className,
  description,
  onSelect,
  buttonText,
}) => {
  const styles = useTextSuggestionListStyle();

  return (
    <div className={mergeClasses(className, 'text-suggestion-list')}>
      {description ? <p className={mergeClasses(styles.description, 'description')}>{description}</p> : null}
      <div className={mergeClasses(styles.suggestions, 'suggestions')}>
        {suggestions.map((suggestion) => (
          <SingleTextSuggestion text={suggestion.text} onSelect={onSelect} key={suggestion.text} buttonText={buttonText} className={mergeClasses(styles.suggestionItem, 'suggestion-item')} />
        ))}
      </div>
    </div>
  );
});

TextSuggestionList.defaultProps = {
  description: '',
  className: '',
};
